import { render } from "./item.vue?vue&type=template&id=2c502c1a&scoped=true"
import script from "./item.vue?vue&type=script&lang=ts"
export * from "./item.vue?vue&type=script&lang=ts"

import "./item.vue?vue&type=style&index=0&id=2c502c1a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-2c502c1a"

export default script